export default "__VITE_ASSET__CPE$L2Dj__"